export default "__VITE_ASSET__CE_SKH1S__"